import { render, staticRenderFns } from "./VatBlock.vue?vue&type=template&id=47129a9d&"
import script from "./VatBlock.vue?vue&type=script&lang=js&"
export * from "./VatBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports